import React, { Fragment } from 'react';

import ResetearClaveContent from '../../components/Usuarios/ResetPasswordContent';
export default function Reset() {
  return (
    <Fragment>
      <ResetearClaveContent />
    </Fragment>
  );
}